import {
  Action,
  ActionType,
  IResendMessageResponse,
} from "models/messagemanagement/resendMessage";
import createReducer from "../../createReducer";

export interface ResendMessageReducerType {
  loading: boolean;
  error?: string;
  resendMessageResponse?: IResendMessageResponse;
}

const defaultState: ResendMessageReducerType = {
  loading: false,
  error: undefined,
  resendMessageResponse: undefined,
};

export const resendMessageReducer = createReducer<ResendMessageReducerType>(
  defaultState,
  {
    [ActionType.RESEND_MESSAGE](state: ResendMessageReducerType) {
      return {
        ...state,
        loading: true,
      };
    },

    [ActionType.RESEND_MESSAGE_ERROR](
      state: ResendMessageReducerType,
      action: Action<number>
    ) {
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    },

    [ActionType.RESEND_MESSAGE_SUCCESS](
      state: ResendMessageReducerType,
      action: Action<number>
    ) {
      return {
        ...state,
        loading: false,
        error: null,
        resendMessageResponse: action.payload,
      };
    },

    [ActionType.RESEND_MESSAGE_RESET](state: ResendMessageReducerType) {
      return {
        ...state,
        loading: false,
        error: null,
        resendMessageResponse: undefined,
      };
    },
  }
);
